import { LicensePrePaidSubFormBaseDataProvider } from './LicensePrePaidSubFormBaseDataProvider';
import { PrePaidLicenseInformation } from '../../types/PrePaidLicenseInformation';
import { htmlEncode } from '../../../utils/escape.utils';

export class LicensePrePaidSubFormGzDataProvider extends LicensePrePaidSubFormBaseDataProvider {
  public async getLicenseKeyInfo(
    licenseKeyFieldValue: string,
    companyId: string | null,
    returnIncompatibleProducts: boolean
  ): Promise<PrePaidLicenseInformation> {
    return await this.dependencies.api.clients.Licenses.GetLicenseKeyInfo(
      licenseKeyFieldValue,
      companyId,
      returnIncompatibleProducts
    ).toPromise();
  }

  public async getRootVisibilityTree(): Promise<string> {
    const rootVisibilityTree = await this.dependencies.api.clients.Company.GetRootVisibilityTree().toPromise();
    return htmlEncode(rootVisibilityTree);
  }
}
